export enum ULFEvents {
  PAGE_VIEW = "PAGE_VIEW", // open any page (home, offer details, basket, checkout, dashboard, ...)
  REDIRECT_TO_HOME_PAGE = "REDIRECT_TO_HOME_PAGE",
  REACTIVATE_CLICKED = "REACTIVATE_CLICKED", // click reactivate button
  CANCEL_CLICKED = "CANCEL_CLICKED", // cancel button and X clicked
  CANCEL_CONFIRMATION_CLICKED = "CANCEL_CONFIRMATION_CLICKED", // send reason on body
  REDIRECT_TO_PARTNER_PAGE = "REDIRECT_TO_PARTNER_PAGE", // after click on setup, click on "go to partnerName"
  BASKET_ADD = "BASKET_ADD",
  BASKET_REMOVE = "BASKET_REMOVE",
  SUBSCRIPTION_PURCHASE = "SUBSCRIPTION_PURCHASE",
  LOGOUT = "LOGOUT",
  GO_BACK = "GO_BACK",
  REDIRECT_TO_DOWNLOAD_APP = "REDIRECT_TO_DOWNLOAD_APP",
  HELP_FORGOT_PASSWORD_CLICKED = "HELP_FORGOT_PASSWORD_CLICKED",
  CALLBACK_ACTIVATION = "CALLBACK_ACTIVATION",
  CALLBACK_INITIATION = "CALLBACK_INITIATION",
  CAROUSEL_CLICKED = "CAROUSEL_CLICKED",
  REVOKE_DOWNGRADE = "REVOKE_DOWNGRADE",
}

export interface ULFData {
  channel: string;
  design: string;
  "event-name": ULFEvents;
  "offer-name": string | null;
  page: string;
  partner: string | null;
  source: string | "marketplace";
  "x-vf-trace-timestamp": number;
  reason: string | null;
  "device-type": string;
  proposition: string;
}
